import { render, staticRenderFns } from "./EnviarMensagemPrincipal.vue?vue&type=template&id=4a999ba7&"
import script from "./EnviarMensagemPrincipal.vue?vue&type=script&lang=js&"
export * from "./EnviarMensagemPrincipal.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports